<div class="flex items-center justify-center dialog-header ">
    Create Course

    <div class="absolute right-2">
        <button
            (click)="handleCloseDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>



<div class="dialog-content">
    <form [formGroup]="courseForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">
  
      <!-- Campus -->
      <div class="flex flex-col">
        <label for="campus_id" class="mb-2 font-semibold">Campus *</label>
        <p-select id="campus_id" formControlName="campus_id" [options]="campusOptions" 
          placeholder="Select a campus" class="w-full" />
        <div *ngIf="courseForm.get('campus_id')?.invalid && (courseForm.get('campus_id')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Campus is required.
        </div>
      </div>
  
      <!-- Department -->
      <div class="flex flex-col">
        <label for="dept_id" class="mb-2 font-semibold">Department</label>
        <p-select id="dept_id" formControlName="dept_id" [options]="deptOptions" 
          placeholder="Select a department" class="w-full" />
        <div *ngIf="courseForm.get('dept_id')?.invalid && (courseForm.get('dept_id')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Department is required.
        </div>
      </div>
  
      <!-- Name -->
      <div class="flex flex-col">
        <label for="name" class="mb-2 font-semibold">Name *</label>
        <input pInputText id="name" formControlName="name" class="w-full border rounded focus:ring-2" />
        <div *ngIf="courseForm.get('name')?.invalid && (courseForm.get('name')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Name is required.
        </div>
      </div>
  
      <!-- Code -->
      <div class="flex flex-col">
        <label for="code" class="mb-2 font-semibold">Code *</label>
        <input pInputText id="code" formControlName="code" class="w-full border rounded focus:ring-2" />
        <div *ngIf="courseForm.get('code')?.invalid && (courseForm.get('code')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Code is required.
        </div>
      </div>
  
      <!-- Description -->
      <div class="flex flex-col col-span-2">
        <label for="description" class="mb-2 font-semibold">Description</label>
        <textarea pInputText id="description" formControlName="description" rows="3"
          class="w-full border rounded focus:ring-2"></textarea>
      </div>
  
      <!-- Duration -->
      <div class="flex flex-col">
        <label for="duration" class="mb-2 font-semibold">Duration (Months) *</label>
        <input pInputText type="number" id="duration" formControlName="duration" class="w-full border rounded focus:ring-2" />
        <div *ngIf="courseForm.get('duration')?.invalid && (courseForm.get('duration')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Duration is required.
        </div>
      </div>
  
      <!-- Status -->
      <div class="flex flex-col">
        <label for="status" class="mb-2 font-semibold">Status *</label>
        <p-select id="status" [options]="statusOptions" formControlName="status" placeholder="Select status"
          class="w-full" />
        <div *ngIf="courseForm.get('status')?.invalid && (courseForm.get('status')?.touched || submitted)"
          class="text-red-500 text-xs mt-1">
          Status is required.
        </div>
      </div>
  
      <!-- Submit Button -->
      <div class="col-span-2 flex justify-end mt-6">
        <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
          [disabled]="courseForm.invalid || isLoading"></p-button>
      </div>
    </form>
  </div>
  